"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callbackTokenDefaulTtlMs = exports.callbackTokenMaxTtlMs = void 0;
const names_and_enums_1 = require("../names-and-enums");
function callbackTokenMaxTtlMs() {
    return names_and_enums_1.DayMs;
}
exports.callbackTokenMaxTtlMs = callbackTokenMaxTtlMs;
function callbackTokenDefaulTtlMs() {
    return 15 * names_and_enums_1.MinuteMs;
}
exports.callbackTokenDefaulTtlMs = callbackTokenDefaulTtlMs;
//# sourceMappingURL=callback-token-duration.js.map